import CustomSoundStatusPill from "./CustomSoundStatusPill"
import { useEffect, useMemo, useState } from "react"
import Table, { SelectColumnFilter } from "../../components/table/Table"
import api from "../../components/utils/api"
import DirectLink from "../../components/template/DirectLink"
import Spinner from "../../components/template/Spinner"
import ButtonFull from "../../components/template/ButtonFull"
import { useNavigate } from "react-router-dom"

const CustomSoundTable = () => {
    const [data, setData] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await api.get(`/api/custom-sounds`)
                setData(res.data.requests)
            } catch (err) {
                console.error(err)
            }
        }
        fetchData()
    }, [])

    const columns = useMemo(
        () => [
            {
                Header: "Request ID",
                accessor: "request_id",
            },
            {
                Header: "Custom Sound ID",
                accessor: "custom_sound_id",
            },
            {
                Header: "Service ID",
                accessor: "service_id",
            },
            {
                Header: "Detail",
                accessor: "detail",
                Cell: ({ row }) => <div>
                    <ButtonFull contents={"Detail"} onClick={() => navigate(`/custom-sound/detail/${row.original.request_id}`)} />
                </div>
            },
            {
                Header: "User",
                accessor: "org_uuid",
                Filter: SelectColumnFilter,
                filter: 'exactText',
            },
            {
                Header: "Request Type",
                accessor: "req_type",
                Cell: ({ row }) => <div className="text-center">{row.original.req_type.split("_")[0]}</div>
            },
            {
                Header: "Environment",
                accessor: "env",
                Filter: SelectColumnFilter,
                filter: 'exactText',
            },
            {
                Header: "Requested At",
                accessor: "requested_at",
            },
            {
                Header: "Completed At",
                accessor: "completed_at",
            },
            {
                Header: "Status",
                accessor: "status",
                Filter: SelectColumnFilter,
                filter: 'exactText',
                Cell: CustomSoundStatusPill,
            },
            {
                Header: "Deploy",
                accessor: "deployment",
                Cell: ({ row }) => (<>{
                    row.original.status === "completed" ?
                        <DirectLink path={`${process.env.REACT_APP_BIZ_DOMAIN}/models?service_id=${row.original.service_id}`} title={`Direct link for the model deployment`} />
                        : <div className='pt-2 pl-2'><Spinner /></div>
                }</>)
            },
        ], []
    )

    return (
        <Table columns={columns} data={data} />
    )
}

export default CustomSoundTable